// Enum to position elements on the page for the TablePageLayout
export enum PAGE_POSITIONS {
  TOP_RIGHT_TABLE_CONTAINER = 'topRightTableContainer',
  TOP_RIGHT_PAGE = 'topRightPage',
}
